import { Card } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatDecimal, formatInt } from 'scenes/VisitHistory/utils/format';

import { MaterialSummary } from '../utils/storeVisits';

const I18N_BASE = 'scenes.store_visits.materials';
const CSS = 'visit-history-inc';

interface StoreVisitsMaterialsProps {
  summary: MaterialSummary;
}

/** Unidades implementadas en locales: top 5 y el resto agrupado. */
function StoreVisitsMaterials({ summary }: StoreVisitsMaterialsProps) {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const rows = [
    ...summary.top,
    ...(summary.other
      ? [
          {
            key: '__other__',
            label: t(`${I18N_BASE}.other`, { count: summary.other.materials }),
            units: summary.other.units,
            pct: summary.other.pct,
          },
        ]
      : []),
  ];
  const max = Math.max(1, ...rows.map((row) => row.units));

  return (
    <Card
      className={`${CSS} store-visits-materials`}
      title={t(`${I18N_BASE}.title`)}
    >
      <div className="store-visits-materials__total">
        <strong>{formatInt(summary.units, language)}</strong>
        <span>{t(`${I18N_BASE}.units`)}</span>
      </div>
      <div className="store-visits-materials__meta">
        {t(`${I18N_BASE}.meta`, {
          count: summary.materials,
          perStore: formatDecimal(summary.perExecuted, language),
        })}
      </div>
      {rows.length === 0 ? (
        <div className={`${CSS}__empty`}>{t(`${I18N_BASE}.empty`)}</div>
      ) : (
        <ol className={`${CSS}__list`}>
          {rows.map((row) => (
            <li key={row.key}>
              <div className={`${CSS}__row store-visits-materials__row`}>
                <span />
                <span className={`${CSS}__name`} title={row.label}>
                  {row.label}
                </span>
                <span className={`${CSS}__count`}>
                  {formatInt(row.units, language)}
                </span>
                <span className={`${CSS}__pct`}>{`${row.pct}%`}</span>
                <span className={`${CSS}__bar`}>
                  <span style={{ width: `${(row.units / max) * 100}%` }} />
                </span>
              </div>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}

export default StoreVisitsMaterials;
